import styled from "styled-components";
import { Row } from "antd";

export const RowAnt = styled(Row)`
    // margin-top: -142px;
`;